import axios from "axios";

export const actions = {
    getPaymentAudits(store, params) {
        const { pageSize = 10, page = 1, sorts = null, filters = null } = params;

        let query = `page=${page}&pageSize=${pageSize}`;
        if (sorts) {
            query += `&${sorts}`;
        }
        if (filters) {
            query += `&${filters}`;
        }
        query = encodeURI(query);

        const url = `/tables/payment-audits?${query}`;
        return axios.get(url);
    },
};
